var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"bem",rawName:"v-bem"}]},[_c('div',{directives:[{name:"bem",rawName:"v-bem:actions",arg:"actions"}]},[_c('v-dropdown',{attrs:{"options":[
                {
                    name: 'Vaults',
                    value: 'vaults',
                    icon: 'folder'
                },
                {
                    name: 'Flat: recently viewed',
                    value: 'recent',
                    icon: 'clock'
                },
                {
                    name: 'Flat: frequently used',
                    value: 'frequent',
                    icon: 'bolt'
                },
                {
                    name: 'Flat: A-Z',
                    value: 'a-z',
                    icon: 'sort-alpha-down'
                },
                {
                    name: 'Flat: Z-A',
                    value: 'z-a',
                    icon: 'sort-alpha-up'
                }
            ],"anchor":"left","drop-up":""}},[_c('v-icon-button',{attrs:{"icon":"filter","type":"white-dull","invert":"light","solid":""}})],1),_c('v-icon-button',{attrs:{"icon":"home","type":"white-dull","invert":"light","solid":""},on:{"click":_vm.closeAllVaults}}),_c('v-icon-button',{attrs:{"icon":"sync-alt","type":"white-dull","invert":"light","solid":"","modifier":_vm.refreshing ? 'rotating' : ''},on:{"click":_vm.refreshVaults}})],1),_c('div',{directives:[{name:"bem",rawName:"v-bem:new-entry",arg:"new-entry"}]},[_c('v-dropdown',{attrs:{"options":_vm.schemas,"anchor":"left","full-width":"","drop-up":""},on:{"input":_vm.newEntry}},[_c('v-button',{attrs:{"type":"grey-dark","invert":"light","icon-left":"plus","size":"md","full-width":"","float-icon":""}},[_vm._v("\n                New entry\n            ")])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }